import React, { FC } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { usePermissions } from 'react-admin';
import { useRightContentSpacing } from '~/hooks/styles';
import { useGetApprovalCase } from '~/hooks/approvals';
import { HeadTransaction } from '~/types/HeadTransaction';
import AsideDetails from './AsideDetails';
import AsideReferences from './AsideReferences';
import AffiliatedObjects from '~/components/AffiliatedObjects';
import ApprovalFlow from '~/components/Approvals/ApprovalFlow';

type Props = {
  record?: HeadTransaction;
  resource?: string;
};

const RightPanel: FC<any> = (props: Props) => {
  const { record: trx, resource } = props;

  const spacing = useRightContentSpacing();
  const classes = useStyles({ spacing });

  const { permissions } = usePermissions();
  const canViewApprovalCase =
    permissions?.includes('approvalCase.view') || permissions?.includes('approvalCase.admin');
  const {
    data: approvalCase,
    refetch: refetchApprovalCase,
    isError: isErrorApprovalCase,
  } = useGetApprovalCase(trx?.details?.approvalCase?.id, canViewApprovalCase);

  if (!trx) {
    return null;
  }

  return (
    <Grid container item xs direction='column' spacing={spacing}>
      <Grid item className={classes.asideContent}>
        <AsideDetails record={trx} />
        {approvalCase && !isErrorApprovalCase && (
          <Box mb={2}>
            <ApprovalFlow
              record={approvalCase}
              resource={resource}
              onActionEnd={() => {
                refetchApprovalCase();
                return Promise.resolve();
              }}
            />
          </Box>
        )}
        {(trx.details.deal ||
          trx.details.reversalTransaction ||
          trx.details.revertedTransaction ||
          trx.details.approvalTransaction ||
          trx.details.approvedTransaction ||
          trx.details.settlementTransaction ||
          trx.details.settledTransaction ||
          trx.details.payroll) && <AsideReferences record={trx} />}
      </Grid>
      {trx?.details?.references && (
        <AffiliatedObjects
          id={trx.id}
          references={trx?.details?.references}
          resource='transactions'
          withAdd={false}
          withArchive={false}
          withViewAll={false}
        />
      )}
    </Grid>
  );
};

type StylesPrpos = {
  spacing: number;
};

const useStyles = makeStyles<Theme, StylesPrpos>((theme) => ({
  asideContent: {
    marginLeft: ({ spacing }) => theme.spacing(spacing),
  },
}));

export default RightPanel;
